<template>
    <div class="main-wrapper">
        <layout-header />

        <div>
            <div class="overflow-hidden bg-light bg-cover bg-no-repeat pb-md-5 pb-4 rounded-none position-relative w-100 features-img"
                :style="'padding-top: 120px;background-position:center;background-image: url('+ featuredImage || defaultFeaturedImage +');'">
                <div class="container px-4 pt-3 pt-lg-5 mx-auto position-relative" style="z-index: 1">
                    <figure class="bg-white rounded-xl p-2 d-inline-block mb-2" style="max-width: 100px">
                        <a :href="'/partner/'+establishment.id">
                            <img :src="logo || defaultLogoPath" class="w-100 h-auto">
                        </a>
                    </figure>
                    <h1 class="font-weight-bold text-white mb-0">Terrain {{ facility.name }}</h1>
                    <a class="h3 text-white mb-2" :href="'/partner/'+establishment.id">{{ establishment.business_name }}</a>
                    <address class="my-2">
                        <p class="text-sm text-white">{{ establishment.address }}, {{ establishment.delegation }}</p>
                    </address>
                    <div class="d-block d-sm-flex align-items-center font-weight-semibold text-white my-2">
                        <a :href="'mailto:'+establishment.email" class="d-flex align-items-center mr-3">
                            <span class="material-symbols-outlined text-sm text-white mr-1">mail</span>
                            <p class="text-sm text-white">{{ establishment.email }}</p>
                        </a>
                        <a :href="'https://www.google.com/maps/search/?api=1&amp;query='+establishment.latitude+','+establishment.longitude"
                            target="_blank" rel="noreferrer" class="d-flex align-items-center">
                            <span class="material-symbols-outlined text-sm text-white mr-1">location_on</span>
                            <p class="text-sm text-white">Obtenir Directions</p>
                        </a>
                    </div>
                </div>
            </div>
            <div class="d-flex container justify-content-between align-items-center border-bottom mb-3 sticky-top bg-white px-2 pt-3"
                style="top: 86px;">
                <ul class="nav nav-tabs nav-tabs-bottom nav-justified">
                    <li class="nav-item">
                        <a class="nav-link" :class="{ active: activeSection === 'book' }"
                            @click.prevent="scrollTo('book')">Réserver</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" :class="{ active: activeSection === 'business_hours' }"
                            @click.prevent="scrollTo('business_hours')">Horaires</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" style="width: max-content !important;" :class="{ active: activeSection === 'about' }"
                            @click.prevent="scrollTo('about')">À Propos</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" :class="{ active: activeSection === 'review' }"
                            @click.prevent="scrollTo('review')">Évaluer</a>
                    </li>
                </ul>
            </div>
            <div class="container mb-5 pb-5">
                <section id="book" class="mb-5">
                    <div class="d-flex">
                        <div class="form-group card-label mx-1 mb-2" style="width: 60%; max-width: 300px;">
                            <label>Date</label>
                            <input type="text" class="form-control date" readonly v-model="formattedDate" required />
                        </div>
                        <div class="form-group card-label mx-1 mb-2" style="width: 40%; max-width: 300px;" v-if="establishment.facilities?.length > 1">
                            <label>Terrain</label>
                            <select class="form-control custom-select" v-model="facility_id">
                                <option v-for="facility in establishment.facilities" :value="facility.id">{{ facility.name }}</option>
                            </select>
                            <!-- <input type="text" class="form-control date w-50" readonly v-model="formattedDate"
                                style="max-width: 50%; width: 300px;" required /> -->
                        </div>
                    </div>
                    <div v-for="(timeOfDaySlots, timeOfDay) in this.framedSlots" class="row px-3">
                        <div class="col-12 text-center text-muted text-sm position-relative mt-3 mb-1" v-if="timeOfDaySlots.length > 0">
                            <hr class="position-absolute inset-0 my-0" style="top: 50%;"/>
                            <span class="my-2 px-3 bg-white position-relative">{{ timeOfDay }}</span>
                        </div>
                        <div class="col-lg-3 col-md-4 col-6 text-xs px-md-2 px-lg-3" v-for="(slot, index) in timeOfDaySlots" :class="{'pl-2 pr-0': index % 2 !== 0, 'pl-0 pr-2': index % 2 === 0}">
                            <div class="border rounded-xl my-2" :class="{ 'bg-light': !slot.available && ( !slot.expires_at || slot.expires_at >= now )}">
                                <div>
                                    <div class="d-flex justify-content-between align-items-center pl-3 pr-2 pt-3">
                                        <h5 class="m-0">
                                            <i class="far fa-clock pr-1"></i>
                                            {{ formatTime(slot.start_time) }} - {{ formatTime(slot.end_time) }}
                                        </h5>
                                    </div>
                                    <div class="d-flex justify-content-between align-items-center p-3">
                                        <h5 class="flex-fill m-0 text-muted">
                                            <b v-if="!slot.sale_price">{{ slot.price }}<sup>DT</sup></b>
                                            <s class="mr-1" v-if="slot.sale_price">{{ slot.price }}<sup>DT</sup></s>
                                            <b v-if="slot.sale_price">{{ slot.sale_price }}<sup>DT</sup></b>
                                        </h5>
                                        <div class="text-sm">
                                            <span class="badge badge-pill bg-secondary-light p-2"
                                                v-if="slot.available && slot.start_time <= now">
                                                expiré
                                            </span>
                                            <span class="badge badge-pill bg-success-light p-2"
                                                v-else-if="(slot.available || ( slot.expires_at && slot.expires_at <= now ) ) && slot.start_time > now">disponible</span>
                                            <span class="badge badge-pill bg-warning-light p-2"
                                                v-else-if="!slot.available && slot.expires_at && slot.expires_at > now && slot.start_time > now">
                                                en cours</span>
                                            <span class="badge badge-pill bg-danger-light p-2"
                                                v-else-if="slot.available">réservé</span>
                                        </div>
                                    </div>
                                    <div class="w-100 px-3 pb-3 pt-0">
                                        <!-- <button type="button" v-if="(slot.available || (slot.expires_at && slot.expires_at < now) || (slot.status === 'pending' && slot.expires_at && slot.expires_at > now)) && currentUser.role === 'player'"
                                            class="btn btn-secondary rounded-xl w-100" @click="prebook(slot)">
                                            {{ slot.status === 'pending' && slot.expires_at && slot.expires_at > now ? 'Réserver quand même' : 'Réserver' }}
                                        </button> -->
                                        <button type="button" v-if="(slot.available || (slot.expires_at && slot.expires_at < now)) && (!currentUser?.id || currentUser.role === 'player')"
                                            class="btn btn-secondary rounded-xl w-100" @click="prebook(slot)">Réserver</button>
                                        <button type="button" v-else-if="!slot.available || ( slot.expires_at && slot.expires_at > now )" :disabled="true"
                                            class="btn btn-secondary rounded-xl w-100">Réserver</button>
                                        <a type="button" v-else-if="!currentUser.is_verified"
                                            class="btn btn-secondary rounded-xl w-100" href="/login">Se connecter</a>
                                        <!--<button type="button" v-else-if="" @click="$router.push({name: 'login', query: {redirect: $route.path}})"
                                            class="btn btn-secondary rounded-xl w-100">Réserver</button>-->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section id="business_hours" class="mb-5">
                    <h3><b>Horaires et Emplacement</b></h3>
                    <div class="row mx-0 my-3 d-flex align-items-stretch">
                        <div class="col-lg-4 col-md-5 col-sm-5 bg-light rounded-xl my-1 p-3">
                            <span class="d-block mb-3 text-sm">{{ establishment.address }}, {{ establishment.delegation }}</span>
                            <div class="d-flex flex-row justify-content-between align-items-center my-1"
                                v-for="businessDay in establishment.business_hours" :key="businessDay.day" style="min-height: 31px;">
                                <span class="pl-0 text-left" style="width: 100px;">{{ getDayNameInFrench(businessDay.day) }}</span>
                                <div v-if="businessDay.is_active">
                                    <span>{{ businessDay.open }} - {{ businessDay.close }}</span>
                                </div>
                                <div v-if="!businessDay.is_active">
                                    <span class="badge bg-danger-light py-2 px-3 rounded-pill">Fermé</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-8 col-md-7 col-sm-7 rounded-xl my-1 px-0 pl-sm-3">
                            <GoogleMap class="rounded-xl bg-light h-100 overflow-hidden" style="min-height: 300px;" :center="mapCenter" :zoom="18" :options="{
                                mapTypeId: 'hybrid',
                            }" />
                        </div>
                    </div>
                </section>
                <section id="about" style="min-height: 400px;">
                    <h3><b>À Propos</b></h3>
                </section>
                <section id="review" style="min-height: 400px;">
                    <h3><b>Évaluer Votre Expérience</b></h3>
                    <p class="text-muted">Veuillez prendre un instant pour évaluer votre expérience dans ce terrain et nous faire part de vos commentaires précieux.</p>
                    <h5>Évaluations et Commentaires</h5>
                    <!-- Ratings summary -->
                    <div class="row mb-4" style="max-width:500px;">
                        <div class="col-5 px-0 mt-1 text-center">
                            <h1 class="display-4 mb-0">{{ averageRating.toFixed(1) }}</h1>
                            <div>
                                <i v-for="n in 5" :key="n" class="material-icons"
                                    :class="{ 'text-warning': n <= Math.round(averageRating) }">
                                    star
                                </i>
                            </div>
                            <small class="text-muted">{{ totalRatings }} éval.</small>
                        </div>
                        <div class="col-7 pr-0">
                            <div v-for="n in 5" :key="n" class="d-flex align-items-center mb-1">
                                <span class="mr-1 text-center" style="min-width: 10px;">{{ n }}</span>★
                                <div class="progress flex-grow-1 ml-2" style="height: 8px;">
                                    <div class="progress-bar bg-warning" role="progressbar"
                                        :style="{ width: ratingPercent(n) + '%' }" :aria-valuenow="ratingPercent(n)"
                                        aria-valuemin="0" aria-valuemax="100">
                                    </div>
                                </div>
                                <span class="ml-1 text-center" style="min-width: 30px;">{{ ratings[n] || 0 }}</span>
                            </div>
                        </div>
                    </div>
                    <form class="mb-4 d-block" style="height: auto" @submit.prevent="submitForm" novalidate v-if="currentUser.role === 'player'">
                        <h5>Évaluer ici</h5>
                        <!-- Star rating -->
                        <div class="form-group" style="margin-bottom: .5rem">
                            <div class="rating-group" aria-label="Star rating">
                                <input type="radio" v-model="userRating.rating" :disabled="userRating?.id" id="rating-5" value="5" required>
                                <label for="rating-5" class="star-label"><i class="material-icons">{{ userRating.rating >= 5 ? 'star' : 'star_border' }}</i></label>

                                <input type="radio" v-model="userRating.rating" :disabled="userRating?.id" id="rating-4" value="4">
                                <label for="rating-4" class="star-label"><i class="material-icons">{{ userRating.rating >= 4 ? 'star' : 'star_border' }}</i></label>

                                <input type="radio" v-model="userRating.rating" :disabled="userRating?.id" id="rating-3" value="3">
                                <label for="rating-3" class="star-label"><i class="material-icons">{{ userRating.rating >= 3 ? 'star' : 'star_border' }}</i></label>

                                <input type="radio" v-model="userRating.rating" :disabled="userRating?.id" id="rating-2" value="2">
                                <label for="rating-2" class="star-label"><i class="material-icons">{{ userRating.rating >= 2 ? 'star' : 'star_border' }}</i></label>

                                <input type="radio" v-model="userRating.rating" :disabled="userRating?.id" id="rating-1" value="1">
                                <label for="rating-1" class="star-label"><i class="material-icons">{{ userRating.rating >= 1 ? 'star' : 'star_border' }}</i></label>
                            </div>
                        </div>

                        <!-- Review text -->
                        <div class="form-group">
                            <label class="text-sm">Commentaire (optionnel):</label>
                            <textarea class="form-control" style="border: 1px solid lightgray" id="review" v-model="userRating.comment" rows="4"
                                placeholder="Partager ton expérience..." required :disabled="userRating?.id"></textarea>
                        </div>

                        <span class="spinner-border spinner-border-sm text-white m-1 d-none" role="status" aria-hidden="true"></span>
                        <button type="submit" v-if="!userRating?.id" class="btn btn-primary btn-rounded text-sm px-4">Envoyer</button>
                        <button type="button" v-else class="btn btn-danger btn-rounded text-sm px-4">Supprimer</button>
                    </form>
                </section>
            </div>
        </div>

        <layout-footer />
    </div>
</template>
<style lang="css" scoped>
.nav-tabs.nav-justified > li > a {
    cursor: pointer;
}

.rating-group {
    display: inline-flex;
    flex-direction: row-reverse;
    justify-content: center;
}

.rating-group input {
    position: absolute !important;
    opacity: 0 !important;
}

.star-label {
    cursor: pointer;
    color: #ffc107;
    /* Bootstrap warning yellow */
    padding: .25rem;
    transition: transform .1s ease-in-out;
}

.star-label:hover {
    transform: scale(1.2);
}

.material-icons {
    font-size: 1.5rem;
}

form .material-icons {
    font-size: 2rem;
}
</style>
<script>
import router from '@/router';
import { GoogleMap } from 'vue3-google-map'
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import moment from "moment";
import 'moment/locale/fr';
import { api } from "@/store";
import bookingManager from '@/utils/booking';
import defaultLogoPath from '@/assets/img/photo.png'
import defaultFeaturedImagePath from '@/assets/img/blog/blog-01.jpg'

export default {
    components: {
        vSelect,
        GoogleMap
    },
    computed: {
        currentUser() {
            return this.$store.getters.currentUser;
        },
        totalRatings() {
            return Object.values(this.ratings).reduce((a, b) => a + b, 0);
        },
        averageRating() {
            const sum = Object.entries(this.ratings)
                .reduce((acc, [stars, count]) => acc + stars * count, 0);
            return this.totalRatings ? sum / this.totalRatings : 0;
        }
    },
    props: ['id'],
    data() {
        return {
            sections: [
                { id: 'book', label: 'Réserver' },
                { id: 'business_hours', label: 'Horaires' },
                { id: 'about', label: 'À-Propos' },
                { id: 'review', label: 'Review' }
            ],
            activeSection: 'bookings',
            now: moment().format('YYYY-MM-DDTHH:mm:ss'),
            date: moment().format('YYYY-MM-DD'),
            formattedDate: null,
            selectedDate: moment().format('YYYY-MM-DD'),
            logo: null,
            featuredImage: null,
            defaultLogo: defaultLogoPath,
            defaultFeaturedImage: defaultFeaturedImagePath,
            facility_id: null,
            facility: {},
            establishment: {},
            slots: [],
            framedSlots: {
                'Nuit': [],
                'Matin': [],
                'Après-midi': [],
                'Soirée': [],
            },
            mapCenter: { lat: 36.8065, lng: 10.1815 },
            userRating: {
                rating: 0,
                comment: null
            },
            ratings: {
                5: 0,
                4: 0,
                3: 0,
                2: 0,
                1: 0
            },
            error: {
                defaults: {
                    icon: 'error',
                    icon_color: 'text-danger',
                    title: 'Erreur',
                    detail: 'Une erreur est survenue. Veuillez réessayer.',
                },
                icon: 'error',
                icon_color: 'text-danger',
                title: 'Erreur',
                detail: 'Une erreur est survenue. Veuillez réessayer.'
            },
        }
    },
    created() {
        this.facility_id = this.id
        this.selectedDate = (this.$route.query.date && (moment(this.$route.query.date)).isValid()) ? this.$route.query.date : this.selectedDate;
        this.getFacility()
        this.getFacilitySlots()
        this.getFacilityRatingSummary()
        if (this.currentUser.role === 'player') {
            this.getMyFacilityRating()
        }
        const selectedDate = $.datepicker.parseDate("yy-mm-dd", this.selectedDate)
        this.formattedDate = $.datepicker.formatDate("DD, d MM yy", selectedDate);
        const vm = this
        $(document).ready(function() {
            const defaultDate = new Date(this.selectedDate);
            $('.date').datepicker({
                dateFormat: 'DD, d MM yy',
                defaultDate: defaultDate,
                minDate: 0,
                maxDate: "+2M",
                onSelect: (dateText) => {
                    const selectedDate = $.datepicker.parseDate("DD, d MM yy", dateText);
                    const formatted = $.datepicker.formatDate("yy-mm-dd", selectedDate);
                    vm.selectedDate = formatted;
                    vm.formattedDate = dateText;
                }
            });
        })
    },
    methods: {
        ratingPercent(stars) {
            return this.totalRatings ? (this.ratings[stars] || 0) / this.totalRatings * 100 : 0;
        },
        submitForm() {
            if (!this.userRating.rating) {
                alert("Please select a rating");
                return;
            }
            this.userRating.rating = parseInt(this.userRating.rating)
            // Update ratings summary
            // this.ratings[this.userRating.rating] = (this.ratings[this.userRating.rating] || 0) + 1;
            $('.submit-section button').attr('disabled', 'disabled')
            $('.submit-section button span').removeClass('d-none')
            api.post(`/private/ratings/facility/${this.id}`, this.userRating)
                .then(response => {
                    const result = response.data
                    this.userRating = result
                    this.$store.dispatch('modal/triggerModal', {
                        icon: 'check_circle',
                        icon_color: 'text-success',
                        title: 'Succès',
                        detail: 'Merci pour votre évaluation !',
                    })
                    // alert("Thanks for your feedback!");
                    this.getFacilityRatingSummary()
                }).catch(error => {
                    console.error(error);
                })
                .finally(() => {
                    $('.submit-section button').removeAttr('disabled')
                    $('.submit-section button span').addClass('d-none')
                })
        },
        getFacility() {
            api.get('/search/facilities/' + this.id)
                .then(response => {
                    const result = response.data
                    this.facility = result
                    this.establishment = this.facility.establishment
                    this.logo = this.facility.establishment.logo_url
                    this.featuredImage = this.getFeaturedImage(this.facility)
                    this.mapCenter.lat = this.establishment.latitude
                    this.mapCenter.lng = this.establishment.longitude
                    this.getEstablishment(this.establishment.id)

                    // Update the Title
                    const facility_name = !this.facility.name.toLowerCase().includes('terrain') ? `Terrain ${this.facility.name}` : this.facility.name
                    document.title = `${facility_name} ${this.establishment.business_name} - ${document.title}`

                    let desc = `Louez le ${facility_name} au complexe ${this.establishment.business_name} à ${this.establishment.delegation}. Terrain de qualité supérieure à ${this.facility.price} DT. Réservez vite en ligne !`;
                    // Update the Meta Description
                    const metaDescription = document.querySelector('meta[name="description"]')
                    if (metaDescription) {
                        metaDescription.setAttribute('content', this.establishment.description || desc)
                    }
                })
        },
        getFacilitySlots() {
            api.get('/search/slots/'+this.selectedDate+'/facility/'+this.id)
            .then(response => {
                const result = response.data
                this.slots = result.filter(slot => !this.timeReached(slot) || this.booked(slot))
                this.framedSlots = {
                    'Nuit': [],
                    'Matin': [],
                    'Après-midi': [],
                    'Soirée': [],
                },
                this.slots.forEach(slot => {
                    const timeOfDay = this.getTimeOfDay(slot.start_time)
                    this.framedSlots[timeOfDay].push(slot) 
                });
            })
        },
        getEstablishment(establishment_id) {
            api.get('/search/establishments/' + establishment_id)
                .then(response => {
                    const result = response.data
                    this.establishment = result
                })
        },
        getMyFacilityRating() {
            api.get('/private/ratings/facility/' + this.id + '/me')
                .then(response => {
                    const result = response.data
                    this.userRating = result ? result : this.userRating
                })
        },
        getFacilityRatingSummary() {
            api.get('/ratings/facility/' + this.id + '/summary')
                .then(response => {
                    const result = response.data
                    this.ratings = result
                })
        },
        timeReached(slot) {
            return slot.start_time <= moment().format('YYYY-MM-DDTHH:mm:ss')
        },
        booked(slot) {
            return slot.status == 'booked'
        },
        prebook(slot) {
            const now = moment().format('YYYY-MM-DDTHH:mm:ss')
            const isPendingDiscussion = slot.status === 'pending' && slot.expires_at && slot.expires_at > now

            const sendPrebookRequest = () => {
                let url = `/prebook/facility/${this.id}`
                url = (!this.currentUser?.id) ? `${url}/create_token` : url
                if (!this.currentUser?.id || this.currentUser.is_verified) {
                    api.post(url, {
                            slot_id: slot.id,
                            facility_id: this.id,
                            start_time: slot.start_time,
                            end_time: slot.end_time,
                        }).then(response => {
                            const res = response.data
                            if (res.status == "success") {
                                if (!this.currentUser?.id) {
                                    // create a prebooking token and redirect to login page
                                    console.log(res)
                                    bookingManager.createToken(res)
                                    router.push('/login')
                                    return
                                }
                                router.push('/booking/' + res['prebooking_id'])
                                return
                            }
                        }).catch(error => {
                            if (error.response) {
                                this.$store.dispatch('modal/triggerModal', {
                                    icon: 'error',
                                    icon_color: 'text-danger',
                                    title: 'Désolé!',
                                    detail: error.response.status >= 500 ? 'Une erreur est survenue! Veuillez réessayer plus tard.' : error.response.data.detail
                                })
                                if (error.response.data?.detail?.error_information) {
                                    router.push('/my/profile')
                                    return
                                }
                            }
                        })
                } else {
                    router.push('/my/profile')
                    return
                    const msg = (this.currentUser.phone_number) ? 'Merci de renseigner votre numéro de téléphone dans votre profil' : 'Merci de vérifier votre numéro téléphone.'
                    this.$store.dispatch('modal/triggerModal', {
                        icon: 'error',
                        icon_color: 'text-danger',
                        title: 'Erreur',
                        detail: msg
                    })
                }
            }

            if (isPendingDiscussion) {
                this.$store.dispatch('modal/triggerModal', {
                    icon: 'warning',
                    icon_color: 'text-warning',
                    title: 'Créneau en discussion',
                    detail: 'Ce créneau est en discussion avec un autre joueur. Vous pouvez le réserver maintenant s’il est encore libre, ou attendre qu’il expire.',
                    prompt: true,
                    onResult: (confirmed) => {
                        if (confirmed) {
                            sendPrebookRequest()
                        }
                    }
                })
                return
            }

            return sendPrebookRequest()
        },
        getTimeOfDay(start_time) {
            const time = this.formatTime(start_time)

            if (time >= '00:00' && time < '04:30') {
                return 'Nuit';
            } else if (time >= '04:30' && time < '11:30') {
                return 'Matin';
            } else if (time >= '11:30' && time < '17:30') {
                return 'Après-midi';
            } else if (time >= '17:30' && time < '23:59') {
                return 'Soirée';
            }
        },
        getFeaturedImage(facility) {
            if (this.isEmpty(facility)) return null
            const featuredImage = facility.images.filter(img => img.role === 'featured')
            if (featuredImage.length > 0) return featuredImage[0]['thumb_large_url']
            return null
        },
        getDayNameInFrench(dayName) {
            const referenceDays = {
                Sunday: 'Dimanche',
                Monday: 'Lundi',
                Tuesday: 'Mardi',
                Wednesday: 'Mercredi',
                Thursday: 'Jeudi',
                Friday: 'Vendredi',
                Saturday: 'Samedi'
            };
            return referenceDays[dayName]
        },
        formatTime(datetimeString) {
            if (!datetimeString) return '';
            const date = new Date(datetimeString);
            // Extract local hours and minutes
            const hours = date.getHours().toString().padStart(2, '0');
            const minutes = date.getMinutes().toString().padStart(2, '0');
            return `${hours}:${minutes}`;
        },
        formatLabel(option) {
            if (!option || typeof option !== "string") return "";
            const [delegation, state] = option.split(", ");
            return '<b>' + delegation + '</b>, ' + state;
        },
        isEmpty(obj) {
            for (const prop in obj) {
                if (Object.hasOwn(obj, prop)) {
                    return false;
                }
            }
            return true;
        },
        scrollTo(id) {
            const el = document.getElementById(id)
            if (el) {
                const yOffset = -173 // offset for sticky nav
                const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset
                window.scrollTo({ top: y, behavior: 'smooth' })
            }
        },
        handleScroll() {
            for (const section of this.sections) {
                const el = document.getElementById(section.id)
                if (el) {
                    const rect = el.getBoundingClientRect()
                    if (rect.top <= 180 && rect.bottom >= 180) {
                        this.activeSection = section.id
                        break
                    }
                }
            }
        }
    },
    mounted() {
        window.addEventListener('scroll', this.handleScroll)
    },
    beforeUnmount() {
        window.removeEventListener('scroll', this.handleScroll)
    },
    watch: {
        'selectedDate': function(newValue) {
            this.getFacilitySlots()
        },
        'facility_id': function(newValue) {
            if (newValue != this.id) {
                window.location.replace('/book/facility/' + newValue)
            } 
        }
    }
}
</script>
